import { combineReducers } from 'redux';

import { reducer as selectedKey } from './State/selectedKey';
import { reducer as moving } from './State/moving';

export default combineReducers({
  selectedKey,
  moving
})
